import React from 'react'

import { useSelector } from 'react-redux'

import { selectAudienceLocations } from '@store/rootResource'
import Theme from '@theme'
import { BlockText } from '../Block/Block.styled'

interface IProps {
  locationCodes: ReadonlyArray<string>
}

const CampaignPreviewPreferredAudienceLocations: React.FC<IProps> = ({ locationCodes }) => {
  const audienceLocations = useSelector(selectAudienceLocations)

  const displayedLocations = audienceLocations.reduce((accum, curr) => {
    if (!locationCodes!.includes(curr.code)) {
      return accum
    }
    return [...accum, curr.display]
  }, [])

  return (
    <BlockText small color={Theme.grey800Color}>
      {displayedLocations.join(', ')}
    </BlockText>
  )
}

export default CampaignPreviewPreferredAudienceLocations
